import React from 'react';

const FIELDS = [
  { key: 'name',          label: 'Company Name *', placeholder: 'Acme Pty Ltd' },
  { key: 'abn',           label: 'ABN',            placeholder: '12 345 678 901' },
  { key: 'address',       label: 'Address',        placeholder: '123 Main St, Sydney NSW 2000' },
  { key: 'contact_name',  label: 'Contact Name',   placeholder: 'Jane Smith' },
  { key: 'contact_phone', label: 'Contact Phone',  placeholder: '+61 400 000 000' },
  { key: 'contact_email', label: 'Contact Email',  placeholder: 'jane@company.com' },
  { key: 'website',       label: 'Website',        placeholder: 'https://company.com' },
];

export const StepCompanyDetails = ({ company, onChange }) => (
  <div className="space-y-4">
    <p className="text-white/50 text-sm">Enter the customer's company information.</p>
    {FIELDS.map(f => (
      <div key={f.key}>
        <label className="block text-xs text-white/50 mb-1">{f.label}</label>
        <input
          type="text"
          value={company[f.key] || ''}
          onChange={e => onChange(f.key, e.target.value)}
          placeholder={f.placeholder}
          className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-white text-sm placeholder-white/20 focus:outline-none focus:border-teal-500/50"
          data-testid={`company-${f.key}`}
        />
      </div>
    ))}
  </div>
);
